import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const CompanyOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './company-overview-page.vue');
};

export const companyOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.COMPANY_OVERVIEW_PAGE,
    components: {
        main: CompanyOverview
    },
    props: {
        main(route: RouteLocation): { companyId?: number } {
            return { companyId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
